"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ApplePayButton = function ApplePayButton(_ref) {
  var buttonStyle = _ref.buttonStyle,
    type = _ref.type,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown;
  return /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Apple Pay",
    id: "apple-pay-button",
    lang: "en",
    onClick: onClick,
    onKeyDown: onKeyDown,
    style: {
      WebkitAppearance: '-apple-pay-button',
      ApplePayButtonType: "".concat(type),
      ApplePayButtonStyle: "".concat(buttonStyle),
      width: '100%',
      borderRadius: '4px'
    },
    type: "button"
  });
};
ApplePayButton.propTypes = {
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  buttonStyle: _propTypes.default.oneOf(['black', 'white', 'white-outline']),
  type: _propTypes.default.oneOf(['buy', 'donate', 'plain', 'set-up', 'book', 'check-out', 'subscribe', 'add-money', 'contribute', 'order', 'reload', 'rent', 'support', 'tip', 'top-up'])
};
ApplePayButton.defaultProps = {
  buttonStyle: 'black',
  type: 'buy'
};
var _default = ApplePayButton;
exports.default = _default;